export var COOKIES = {
    SPLIT_ID: 'splitId',
    CURRENCY: 'currency'
};
//# sourceMappingURL=cache.constants.js.map